import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import {
    Dialog,
    DialogContent,
    DialogTitle,
    DialogDescription,
    DialogHeader,
    DialogFooter,
} from '@/components/ui/dialog';
import { cn } from '@/lib/utils';
import useMediaQuery from '@/hooks/useMediaQuery';
import { AppConfig } from '@/config/app.config';
import { useReleaseLatestListApi } from '../hooks/useReleasesLatestListApi';
import { DateTimeHelper } from '@/utils/dateTimeHelper';
import EMarkdownRenderer from '@/components/everridge/EMarkDownRenderer';

const ReleaseNews = () => {
    const [isOpen, setIsOpen] = useState(true);
    const { t } = useTranslation();

    const isMobile = useMediaQuery(AppConfig.mediaQueries.mobile);

    const { releaseLatestListData, markReadReleaseLatestList } = useReleaseLatestListApi();

    const handleClose = () => {
        setIsOpen(false);
    };

    const handleMarkedRead = async () => {
        const ids = releaseLatestListData?.items?.map((item) => item.id);
        await markReadReleaseLatestList({ ids });
        handleClose();
    };

    if (!releaseLatestListData?.totalCount) return null;

    return (
        <Dialog open={isOpen}>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>
                        <span className="text-2xl font-bold">
                            {t('main.releases.components.whatsNew.title')}
                        </span>
                    </DialogTitle>
                    <DialogDescription />
                </DialogHeader>
                <div
                    className={cn(
                        'max-h-96 min-h-60 flex flex-col gap-6 overflow-y-auto overflow-x-hidden select-none',
                        isMobile && 'max-h-full min-h-full',
                    )}
                >
                    {releaseLatestListData.items?.map((newsItem) => (
                        <article key={newsItem.id} className="flex flex-col gap-4">
                            <div>
                                <h4 className="font-semibold">{`${t(
                                    'main.releases.components.whatsNew.version',
                                )} ${newsItem.version}`}</h4>
                                <span className="text-sm text-popover-600">
                                    {DateTimeHelper.formatDate(newsItem.releasedAt, 2)}
                                </span>
                            </div>
                            <div>
                                <EMarkdownRenderer>{newsItem.content}</EMarkdownRenderer>
                            </div>
                        </article>
                    ))}
                </div>
                <DialogFooter className={cn('', isMobile && 'mt-auto')}>
                    <Button className="w-full" onClick={handleMarkedRead}>
                        {t('elements.buttons.continue')}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};

export default ReleaseNews;
